<template>
	<div class = 'home container'>
	  <div class = 'row'>
	  	<div class = 'col-12 col-md-3'><voc-list v-on:selectvoc="selectVoc"></voc-list></div>
		<div class = 'col-12 col-md-9'><voc :voc="voc"></voc></div>
	  </div>
	</div>
</template>

<script>

import vocList from '@/components/voc-list'
import voc from '@/components/voc'

export default {
    components: {
  	  vocList,
  	  voc
    },
	data () {
		return {
			voc: {
				name: '',
				language: '',
				terms: []
			}
		}
	},
	methods: {
		selectVoc (voc){
			this.$store.dispatch("getVoc",voc).then( () => {
				this.voc.name = voc.name
				this.voc.language = voc.language
				this.voc.terms = voc.terms				
			})
		}
	},
	mounted () {
		this.$store.dispatch('getList')
	}	
}
</script>

<style scoped>
</style>